﻿document.addEventListener('DOMContentLoaded', () => {
    const $vidControls = document.querySelectorAll('.video-controls');

    $vidControls.forEach($vidControl => {
        const type = $vidControl.dataset.type;
        const play = $vidControl.querySelector('.play-video');
        const pause = $vidControl.querySelector('.pause-video');
        const wrapper = $vidControl.closest('.video-wrapper');
        const video = wrapper.querySelector('.video');

        const pauseVid = () => {
            if (type === 'youtube') {
                video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else {
                video.contentWindow.postMessage('{"method":"pause"}', '*');
            }
            pause.classList.remove('is-active');
            play.classList.add('is-active');
            wrapper.classList.add('is-paused');
        }

        const playVid = () => {
            if (type === 'youtube') {
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else {
                video.contentWindow.postMessage('{"method":"play"}', '*');
            }
            pause.classList.add('is-active');
            play.classList.remove('is-active');
            wrapper.classList.remove('is-paused');
        }

        pause.addEventListener('click', (e) => {
            e.preventDefault();
            pauseVid();
        });

        play.addEventListener('click', (e) => {
            e.preventDefault();
            playVid();
        });
    });
});